<div class="container-fluid">
  <div class="col-md-12" *ngIf="isLoading">
    <app-busy [message]="message"></app-busy>
  </div>
  <!--<div class="row">
    <div style="margin-top:15px; margin-bottom:-10px;">
      <h4><span style="padding-right:10px"></span> <i class="fa fa-edit"></i>Carrier Account: <b>{{lblHeading}}</b></h4>
    </div>
  </div>-->
  <!--Form structure-->
  <div class="row" style="margin-top:5px;margin-left:0px;margin-right:0px;padding:0px;">
    <div class="col-md-12" style="margin:0px;padding:0px;">     
      <form class="container frm-top" style="width:100%;" [formGroup]="form" (ngSubmit)="onSubmit(form.value)">
        <fieldset class="scheduler-border">
          <legend class="scheduler-border">Compliance and Legal</legend>
          <div class="row">
            <div class="col-4 text-right ln-sp">
              <label class="control-label">
                <strong>Country</strong>
              </label>
            </div>
            <div class="col-8 ln-sp">
              <input type="text" class="form-control form-control-sm" name="country" formControlName="country" title="" readonly>
            </div>
            <div class="col-4 text-right ln-sp">
              <label class="control-label">
                <strong>BBBEE status</strong>
              </label>
            </div>
            <div class="col-8 ln-sp">
              <input type="text" class="form-control form-control-sm" name="bbbee_status" formControlName="bbbee_status" title="" [ngClass]="{'error':form.controls.bbbee_status.invalid && form.controls.bbbee_status.dirty, 'noerror': form.controls.bbbee_status.valid && form.controls.bbbee_status.dirty}">
              <div class="form-control-feedback text-danger text-small" *ngIf="form.controls.bbbee_status.invalid && form.controls.bbbee_status.dirty">
                <p *ngIf="form.controls.bbbee_status.errors.maxlength">BBBEE status must not be more than 12 characters.</p>
              </div>
            </div>
            <!--<div class="col-4 text-right ln-sp">
        <label class="control-label">
          <strong>CSD Number</strong>
        </label>
      </div>
      <div class="col-8 ln-sp">
        <input type="text" class="form-control" name="csd_number" formControlName="csd_number" title="" [ngClass]="{'error':form.controls.csd_number.invalid && form.controls.csd_number.dirty, 'noerror': form.controls.csd_number.valid && form.controls.csd_number.dirty}">
        <div class="form-control-feedback text-danger text-small" *ngIf="form.controls.csd_number.invalid && form.controls.csd_number.dirty">
          <p *ngIf="form.controls.csd_number.errors.maxlength">CSD Number must not be more than 20 characters.</p>
        </div>
      </div>-->
            <div class="col-4 text-right ln-sp">
              <label class="control-label">
                <strong>Transport Association (Taxi/Bus)</strong>
              </label>
            </div>
            <div class="col-8 ln-sp">
              <select class="form-control form-control-sm" name="assoc_id" formControlName="assoc_id" title="">
                <option *ngFor="let assoc of listAssoc" [ngValue]="assoc.id">{{assoc.desc}}</option>
              </select>
            </div>

            <!--<hr />
            <div class="col-4 text-right ln-sp">

            </div>
            <div class="col-md-8 btn-sp">
              <button title="Close this page" (click)="utility.landingPage()" type="button" id="btnClose" class="btn btn-md btn-primary pull-right" style="width:18%; margin-left:10px; "><i class="fa fa-window-close-o"></i> Close</button>
              <button title="Go to the next page" type="button" id="btnNext" (click)="utility.nextPage(acc.Third)" class="btn btn-md btn-success pull-right" style="width:18%; margin-left:10px; ">Next <i class="fa fa-arrow-circle-right"></i></button>
              <button title="Save change(s)" type="submit" [disabled]="!form.valid" id="btnSave" class="btn btn-md btn-primary pull-right" style="width:18%; margin-left:10px; "><i class="fa fa-save"></i> Save</button>
              <button title="Go to previous carrier account page" type="button" id="btnPrevious" (click)="utility.prevPage(acc.Third)" class="btn btn-md btn-info pull-right" style="width:18%; margin-left:10px; "><i class="fa fa-arrow-circle-left"></i> Previous</button>

            </div>-->
          </div>
          </fieldset>
      </form>
      </div>
    </div>
    
  </div>


  
